export default "__VITE_ASSET__BaZn1Ywz__"